var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"completeReset"},[_c('h4',[_vm._v("重置成功")]),_c('div'),_c('el-button',{staticClass:"loginBtn",attrs:{"type":"primary"},on:{"click":_vm.reLogin}},[_vm._v(" 立 即 登 录 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }